module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOSIgaGVpZ2h0PSIyOSIgdmlld0JveD0iMCAwIDI5IDI5Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGNpcmNsZSBjeD0iMTQuNCIgY3k9IjE0LjQiIHI9IjE0LjQiIGZpbGw9IiM1OUNDOEYiLz4KICAgICAgICA8cGF0aCBzdHJva2U9IiNGRkYiIHN0cm9rZS13aWR0aD0iMS42IiBkPSJNOCAxMy40NTdsNS4xODMgNS4wN0wyMi4xMDUgOS42Ii8+CiAgICA8L2c+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./static/images/check-green.svg
// module id = Bf5b
// module chunks = 1